import React from 'react';
import { PD, SF, SFm } from './tokens';

interface RestCardProps {
  duration?: number;
  cardRef?: (_el: HTMLDivElement | null) => void;
}

const RestCard: React.FC<RestCardProps> = ({ duration, cardRef }) => {
  return (
    <div
      ref={cardRef}
      style={{
        width: 120,
        flex: '0 0 120px',
        background: 'transparent',
        borderRadius: 16,
        border: `0.5px dashed ${PD.cardEdge}`,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 8,
        padding: 14
      }}
    >
      <div
        style={{
          width: 36,
          height: 36,
          borderRadius: '50%',
          background: PD.fill,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <i className="pi pi-moon" style={{ fontSize: 16, color: PD.ink2 }} />
      </div>
      <div style={{ textAlign: 'center' }}>
        <div
          style={{
            fontFamily: SF,
            fontSize: 11,
            fontWeight: 700,
            color: PD.ink3,
            letterSpacing: 0.4,
            textTransform: 'uppercase'
          }}
        >
          Descanso
        </div>
        <div style={{ fontFamily: SFm, fontSize: 16, fontWeight: 600, color: PD.ink, marginTop: 2 }}>
          {duration ?? 0}s
        </div>
      </div>
    </div>
  );
};

export default RestCard;
